import script from "./AddValueTags.vue?vue&type=script&setup=true&lang=js"
export * from "./AddValueTags.vue?vue&type=script&setup=true&lang=js"

import "./AddValueTags.vue?vue&type=style&index=0&id=8ff207ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ff207ce"]])

export default __exports__